// extracted by mini-css-extract-plugin
export default {"SeriesLeadText":"GameSeries-module__SeriesLeadText__Qxuwf","GameResult":"GameSeries-module__GameResult__X88q0","GameLabel":"GameSeries-module__GameLabel__gSwFC"};